import { LegacyHours } from '../../types/api';

/**
 * Pure pilot-hours math for the User Profile page (STD-014 split out of
 * UserProfilePage.tsx). Kept framework-free so it can be unit-tested directly.
 */

/** Sum of the three legacy buckets (pre-2023, 2023, 2024), treating gaps as 0. */
export function sumLegacyHours(legacy: LegacyHours | null | undefined): number {
  if (!legacy) return 0;
  return (legacy.pre_2023 || 0) + (legacy['2023'] || 0) + (legacy['2024'] || 0);
}

/** True when at least one legacy bucket carries a non-zero value. */
export function hasLegacyHours(legacy: LegacyHours | null | undefined): boolean {
  return Boolean(legacy && (legacy.pre_2023 || legacy['2023'] || legacy['2024']));
}

/** Tracked hours + legacy hours, formatted to 2 decimals (matches the UI). */
export function formatTotalPilotHours(
  tracked: number | null | undefined,
  legacy: LegacyHours | null | undefined
): string {
  return ((tracked || 0) + sumLegacyHours(legacy)).toFixed(2);
}

/** Per-year legacy breakdown line, e.g. "pre-2023: 12.5h, 2023: 4.0h". */
export function formatLegacyBreakdown(legacy: LegacyHours | null | undefined): string {
  const parts: string[] = [];
  if (legacy?.pre_2023) {
    parts.push(`pre-2023: ${legacy.pre_2023.toFixed(1)}h`);
  }
  if (legacy?.['2023']) {
    parts.push(`2023: ${legacy['2023'].toFixed(1)}h`);
  }
  if (legacy?.['2024']) {
    parts.push(`2024: ${legacy['2024'].toFixed(1)}h`);
  }
  return parts.join(', ');
}
